import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { SubscriptionParams, createSubscription } from '@utils/backend-api/stripe';

export default function useCreateSubscription() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (params: SubscriptionParams) => createSubscription(params),
    {
      onError: (error: { message: string; redirect_to?: string }) => {
        toast.error(
          error.message || 'Something went wrong. Please refresh this page or try again later.'
        );
        if (error.redirect_to) {
          setTimeout(() => (window.location.href = error.redirect_to), 5000);
        }
      },
    }
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
